import React, { FC, ReactElement } from 'react';
import './MoreWaysTrade.scss';
import ParseHtml from '../common/ParseHtml';

interface IProps {
  moreWaysContent?: string;
}
const MoreWaysTrade: FC<IProps> = ({ moreWaysContent }: IProps): ReactElement => {
  const modifiedContent = !isOwner()
    ? moreWaysContent?.replaceAll(/data-user="owner"/gi, 'class="hide"')
    : moreWaysContent;
  return (
    <div className="moreWaystrade-container">{modifiedContent ? <ParseHtml htmlInput={modifiedContent} /> : ''}</div>
  );
};

export default MoreWaysTrade;
export const isOwner = () => {
  const bodyElement: any = document.getElementsByTagName('body')[0];
  const dataUser = bodyElement?.getAttribute('data-type');
  return dataUser === 'owner' ? true : false;
};
